/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptConnectionInvite200,
  CandidatesParams,
  CompleteConnectionInviteRegistration200,
  CompleteConnectionRegistrationRequest,
  ConnectionCandidate,
  ConnectionInviteRequest,
  InviteOrganisationConnection200,
  InviteSummary,
  ListOrganisationConnectionInvitesParams,
  ListOrganisationConnectionsParams,
  OrganisationConnection,
  Peek200
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Complete registration to accept a connection invite — invitee has no account yet (Case A)
 */
export const completeConnectionInviteRegistration = (
    token: string,
    completeConnectionRegistrationRequest: CompleteConnectionRegistrationRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CompleteConnectionInviteRegistration200>(
      {url: `/api/v1/organisation-connections/invites/${token}/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeConnectionRegistrationRequest, signal
    },
      );
    }
  


export const getCompleteConnectionInviteRegistrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeConnectionInviteRegistration>>, TError,{token: string;data: CompleteConnectionRegistrationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeConnectionInviteRegistration>>, TError,{token: string;data: CompleteConnectionRegistrationRequest}, TContext> => {

const mutationKey = ['completeConnectionInviteRegistration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeConnectionInviteRegistration>>, {token: string;data: CompleteConnectionRegistrationRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  completeConnectionInviteRegistration(token,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteConnectionInviteRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof completeConnectionInviteRegistration>>>
    export type CompleteConnectionInviteRegistrationMutationBody = CompleteConnectionRegistrationRequest
    export type CompleteConnectionInviteRegistrationMutationError = unknown

    /**
 * @summary Complete registration to accept a connection invite — invitee has no account yet (Case A)
 */
export const useCompleteConnectionInviteRegistration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeConnectionInviteRegistration>>, TError,{token: string;data: CompleteConnectionRegistrationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeConnectionInviteRegistration>>,
        TError,
        {token: string;data: CompleteConnectionRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCompleteConnectionInviteRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Accept a connection invite — invitee already has an active account (Case B)
 */
export const acceptConnectionInvite = (
    token: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AcceptConnectionInvite200>(
      {url: `/api/v1/organisation-connections/invites/${token}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getAcceptConnectionInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptConnectionInvite>>, TError,{token: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptConnectionInvite>>, TError,{token: string}, TContext> => {

const mutationKey = ['acceptConnectionInvite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptConnectionInvite>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  acceptConnectionInvite(token,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptConnectionInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptConnectionInvite>>>
    
    export type AcceptConnectionInviteMutationError = unknown

    /**
 * @summary Accept a connection invite — invitee already has an active account (Case B)
 */
export const useAcceptConnectionInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptConnectionInvite>>, TError,{token: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptConnectionInvite>>,
        TError,
        {token: string},
        TContext
      > => {

      const mutationOptions = getAcceptConnectionInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Invite another organisation to connect, by email
 */
export const inviteOrganisationConnection = (
    connectionInviteRequest: ConnectionInviteRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<InviteOrganisationConnection200>(
      {url: `/api/v1/organisation-connections/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectionInviteRequest, signal
    },
      );
    }
  


export const getInviteOrganisationConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrganisationConnection>>, TError,{data: ConnectionInviteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inviteOrganisationConnection>>, TError,{data: ConnectionInviteRequest}, TContext> => {

const mutationKey = ['inviteOrganisationConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteOrganisationConnection>>, {data: ConnectionInviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  inviteOrganisationConnection(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteOrganisationConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof inviteOrganisationConnection>>>
    export type InviteOrganisationConnectionMutationBody = ConnectionInviteRequest
    export type InviteOrganisationConnectionMutationError = unknown

    /**
 * @summary Invite another organisation to connect, by email
 */
export const useInviteOrganisationConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrganisationConnection>>, TError,{data: ConnectionInviteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteOrganisationConnection>>,
        TError,
        {data: ConnectionInviteRequest},
        TContext
      > => {

      const mutationOptions = getInviteOrganisationConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List organisation connections — own org for org admin, all (or filtered) for app admin
 */
export const listOrganisationConnections = (
    params?: ListOrganisationConnectionsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<OrganisationConnection[]>(
      {url: `/api/v1/organisation-connections`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListOrganisationConnectionsQueryKey = (params?: ListOrganisationConnectionsParams,) => {
    return [
    `/api/v1/organisation-connections`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListOrganisationConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganisationConnections>>, TError = unknown>(params?: ListOrganisationConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganisationConnectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganisationConnections>>> = ({ signal }) => listOrganisationConnections(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganisationConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganisationConnections>>>
export type ListOrganisationConnectionsQueryError = unknown


export function useListOrganisationConnections<TData = Awaited<ReturnType<typeof listOrganisationConnections>>, TError = unknown>(
 params: undefined |  ListOrganisationConnectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationConnections>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationConnections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisationConnections<TData = Awaited<ReturnType<typeof listOrganisationConnections>>, TError = unknown>(
 params?: ListOrganisationConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationConnections>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationConnections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisationConnections<TData = Awaited<ReturnType<typeof listOrganisationConnections>>, TError = unknown>(
 params?: ListOrganisationConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List organisation connections — own org for org admin, all (or filtered) for app admin
 */

export function useListOrganisationConnections<TData = Awaited<ReturnType<typeof listOrganisationConnections>>, TError = unknown>(
 params?: ListOrganisationConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnections>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganisationConnectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List invites sent by the caller's organisation — pending, used, or expired (own org for org admin, all or filtered for app admin)
 */
export const listOrganisationConnectionInvites = (
    params?: ListOrganisationConnectionInvitesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<InviteSummary[]>(
      {url: `/api/v1/organisation-connections/invites`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListOrganisationConnectionInvitesQueryKey = (params?: ListOrganisationConnectionInvitesParams,) => {
    return [
    `/api/v1/organisation-connections/invites`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListOrganisationConnectionInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError = unknown>(params?: ListOrganisationConnectionInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganisationConnectionInvitesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>> = ({ signal }) => listOrganisationConnectionInvites(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganisationConnectionInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>>
export type ListOrganisationConnectionInvitesQueryError = unknown


export function useListOrganisationConnectionInvites<TData = Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError = unknown>(
 params: undefined |  ListOrganisationConnectionInvitesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationConnectionInvites>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationConnectionInvites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisationConnectionInvites<TData = Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError = unknown>(
 params?: ListOrganisationConnectionInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationConnectionInvites>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationConnectionInvites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisationConnectionInvites<TData = Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError = unknown>(
 params?: ListOrganisationConnectionInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List invites sent by the caller's organisation — pending, used, or expired (own org for org admin, all or filtered for app admin)
 */

export function useListOrganisationConnectionInvites<TData = Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError = unknown>(
 params?: ListOrganisationConnectionInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisationConnectionInvites>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganisationConnectionInvitesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Check an invite's validity and whether the invitee already has an account (peek — does not consume)
 */
export const peek = (
    token: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Peek200>(
      {url: `/api/v1/organisation-connections/invites/${token}`, method: 'GET', signal
    },
      );
    }
  



export const getPeekQueryKey = (token?: string,) => {
    return [
    `/api/v1/organisation-connections/invites/${token}`
    ] as const;
    }

    
export const getPeekQueryOptions = <TData = Awaited<ReturnType<typeof peek>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPeekQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof peek>>> = ({ signal }) => peek(token, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PeekQueryResult = NonNullable<Awaited<ReturnType<typeof peek>>>
export type PeekQueryError = unknown


export function usePeek<TData = Awaited<ReturnType<typeof peek>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof peek>>,
          TError,
          Awaited<ReturnType<typeof peek>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePeek<TData = Awaited<ReturnType<typeof peek>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof peek>>,
          TError,
          Awaited<ReturnType<typeof peek>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePeek<TData = Awaited<ReturnType<typeof peek>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check an invite's validity and whether the invitee already has an account (peek — does not consume)
 */

export function usePeek<TData = Awaited<ReturnType<typeof peek>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof peek>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPeekQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List organisations inviterOrgId doesn't yet have a connection with, and their admin contact
 */
export const candidates = (
    params: CandidatesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ConnectionCandidate[]>(
      {url: `/api/v1/organisation-connections/candidates`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getCandidatesQueryKey = (params?: CandidatesParams,) => {
    return [
    `/api/v1/organisation-connections/candidates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof candidates>>, TError = unknown>(params: CandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCandidatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof candidates>>> = ({ signal }) => candidates(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof candidates>>>
export type CandidatesQueryError = unknown


export function useCandidates<TData = Awaited<ReturnType<typeof candidates>>, TError = unknown>(
 params: CandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof candidates>>,
          TError,
          Awaited<ReturnType<typeof candidates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCandidates<TData = Awaited<ReturnType<typeof candidates>>, TError = unknown>(
 params: CandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof candidates>>,
          TError,
          Awaited<ReturnType<typeof candidates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCandidates<TData = Awaited<ReturnType<typeof candidates>>, TError = unknown>(
 params: CandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List organisations inviterOrgId doesn't yet have a connection with, and their admin contact
 */

export function useCandidates<TData = Awaited<ReturnType<typeof candidates>>, TError = unknown>(
 params: CandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof candidates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




